export const CarouselItem = ({ imgUrl, imgTitle }: any) => (
  <div className="carousel-item h-full flex justify-center items-center px-5 w-fit">
    <img className="w-auto h-full max-w-[none]" src={imgUrl} alt={imgTitle}></img>
  </div>
);
